// Copyright Carrefour(2022)
//

import useMode from '@/features/useMode'
import useDashboards from './useDashboards'

const { mode, modeG40Monthly, modeG9Weekly, modeSbsWeekly, modeSbsMonthly } = useMode()
const { findDashoardBySelector } = useDashboards()

const hasAccess = (user, selector) => {
  const dashboard = findDashoardBySelector(selector)
  let userPermissions = []

  switch (mode.value) {
    case modeG40Monthly:
      userPermissions = user?.pos_g40?.permissions || []
      break
    case modeG9Weekly:
      userPermissions = user?.pos_g9_std_weekly?.permissions || []
      break
    case modeSbsWeekly:
      userPermissions = user?.pos_g9_sbs_weekly?.permissions || []
      break
    case modeSbsMonthly:
      userPermissions = user?.pos_g9_sbs_monthly?.permissions || []
      break
  }

  return dashboard && dashboard.permission ? userPermissions.includes(dashboard.permission) : true
}

const checkAuthentication = (selector, nextSelector, isLogged) => {
  if (selector.meta.requiresAuth) {
    if (!isLogged.value) {
      return nextSelector({ name: 'Login' })
    }
  }
}

const checkPosPermissions = (selector, nextSelector, user) => {
  if (selector.meta.requirePosAccess) {
    if (
      (!user.pos_g40.active && mode.value === modeG40Monthly) ||
      (!user.pos_g9_std_weekly.active && mode.value === modeG9Weekly) ||
      (!user.pos_g9_sbs_weekly.active && mode.value === modeSbsWeekly) ||
      (!user.pos_g9_sbs_monthly.active && mode.value === modeSbsMonthly) ||
      (selector.name === 'Welcome')
    ) {
      return nextSelector({path: '/'})
    }

  }
}

const usePermissions = () => {
  return {
    hasAccess,
    checkPosPermissions,
    checkAuthentication
  }
}

export default usePermissions
